import { Button } from "reactstrap";
import { ProgressControl } from "../../../components/progressBar";
import { confirmBox } from "../../../components/toast";
import { JobStatus } from "../type";
import { START_JOB, STOP_JOB } from "../message";
import { cancelledIcon, errorIcon, rightIcon } from "../../../constant/icons";

const StopButton = ({ column, rowData }: any) => {
    if (!column.stopButton || !column.stopCallBack) {
        return null;
    }

    return (
        <Button
            className="btn-sm btn btn-danger mt-1"
            onClick={async () => {
                const response = await confirmBox(STOP_JOB);
                if (response && column.stopCallBack) {
                    await column.stopCallBack(rowData);
                }
            }}
        >
            Stop
        </Button>
    );
};

const ProgressStatusLabel = (props: any) => {
    const {column, rowData} = props;
    switch(rowData.jobStatus){
        case JobStatus.DONE.id:{
            return  <div className="progress-info completed">
            <span className="text-success">{rightIcon.icon}completed</span>
          </div>
        }
        case JobStatus.DONE_WITH_ERROR.id:{
            return <h6 className="error_label">{errorIcon.icon}<span>{rowData.jobStatusLabel}</span></h6>
        }
        case JobStatus.ERROR.id:{
            return <h6 className="error_label">{errorIcon.icon}<span>{rowData.jobStatusLabel}</span></h6>
        }
        case JobStatus.CANCELLED.id:{
            return <h6 className="error_label">{cancelledIcon.icon}<span>{rowData.jobStatusLabel}</span></h6>
        }
        case JobStatus.IN_PROGRESS.id:{
            return (
                <>
                    <ProgressControl {...props}/>
                    <StopButton column={column} rowData={rowData} />
                </>
            );
        }
        case JobStatus.IN_PROGRESS_RE_POST.id:{
            return (
                <>
                    <h6>{rowData.jobStatusLabel}</h6>
                    <StopButton column={column} rowData={rowData} />
                </>
            );
        }
        case JobStatus.PENDING.id:{
            return <Button className="btn-sm btn btn-success" onClick={async () => {
                const response = await confirmBox(START_JOB);
                if (response && column.callBack) {
                    column.callBack(rowData)
                }
            }}>Start Process</Button>
        }
        case JobStatus.READY_TO_PROCESS.id:{
            return <h6>{rowData.jobStatusLabel}</h6>
        } 
        default:{
            return <h6>{rowData.jobStatusLabel}</h6>
        }
    }
};

export { ProgressStatusLabel };